import React, { useContext } from "react";
import BreakpointContext from "../../contexts/breakpointContext";
import WeekLinksBar from "./WeekLinksBar";
import WeekLinksDropdown from "./WeekLinksDropdown";

export default function WeekLinks({ path }) {
  const breakpoints = useContext(BreakpointContext);

  return breakpoints.sm ? (
    <WeekLinksBar path={path} />
  ) : (
    <WeekLinksDropdown path={path} />
  );
}
